import { createStoreChunk } from '@core/store'

import { type TSessionDialogId } from '../constants/sessionDialogIds'

type TSessionDialogState = {
    exhausted: boolean
    deferred: TSessionDialogId | null
    pendingNextjsExit: boolean
}

export const sessionDialogStore = createStoreChunk<TSessionDialogState>('sessionDialogs')({
    initialState: {
        exhausted: false,
        deferred: null,
        pendingNextjsExit: false,
    },
    actions: {
        markExhausted: () => ({ exhausted: true }),
        defer: (deferred: TSessionDialogId) => ({ exhausted: true, deferred }),
        clearDeferred: () => ({ deferred: null }),
    },
})
